module.exports = __webpack_public_path__ + "img/peixunzhongxin.1766191f.png";